module.exports = __webpack_public_path__ + "img/icon5.1a14f029.png";